import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_TARGET_RATIONALE_LOOKUP_DATA = "GET_TARGET_RATIONALE_LOOKUP_DATA";

export const service = async () => {
  const options: object = {
    url: `/Api/TargetRationale/GetTargetRtionaleLookup`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_TARGET_RATIONALE_LOOKUP_DATA, service, mock);
